export const SolarmanKeys = {
  appId: '202207271861810',
  language: 'en',
  appSecret: 'e3679b18a97c599da5983eb6fd2f36a9',
  orgId: '2857',
  username: 'mastronardi',
};
